export default __webpack_public_path__ + "src/assets/QuickNode_Mobile.b3903c1619f44c25a2dcace4434d083f.svg";